// extracted by mini-css-extract-plugin
module.exports = {"img":"ProductImg_img__vdowM"};